import { useGetIdentity, useList } from "@refinedev/core";
import type { AppUser } from "types";
import { useSession } from "./useSession";

export const QUESTIONNAIRE_REQUIRED_QUESTION = "USE_CASE";

interface OnboardingAnswerRow {
  question: string;
}

export const useHasCompletedQuestionnaire = (enabled = true) => {
  const { data: identity } = useGetIdentity<AppUser>();
  const userId = identity?.id;
  const { currentOrganization, isLoading: isLoadingSession } = useSession();

  // Teacher orgs run their own onboarding flow (/creator-profile), so the
  // generic questionnaire must never show for them.
  const isTeacherOrg =
    currentOrganization?.onboarding_questionnaire_type === "teacher";

  const { data, isLoading: isLoadingAnswers } = useList<OnboardingAnswerRow>({
    resource: "media/onboarding/answer",
    filters: [{ field: "user_id", operator: "eq", value: userId }],
    queryOptions: {
      enabled: enabled && !!userId && !isLoadingSession && !isTeacherOrg,
    },
  });

  const answers = data?.data ?? [];
  const hasCompletedQuestionnaire = answers.some(
    (a) => a.question === QUESTIONNAIRE_REQUIRED_QUESTION
  );

  // Wait on the session too, otherwise the questionnaire flashes before we
  // know the org type.
  const isLoading =
    isLoadingSession || (!isTeacherOrg && (!userId || isLoadingAnswers));

  return {
    isLoading,
    hasCompletedQuestionnaire,
    isTeacherOrg,
    shouldShowQuestionnaire: !isTeacherOrg && !hasCompletedQuestionnaire,
  };
};
